export const getSectionTitle = (section) => {
    if (section.title) {
        return section.title;
    }
    return 'Untitled';
}